export const AppConstants = {
  SAAS_DOMAIN: import.meta.env.VITE_SAAS_DOMAIN || 'https://app.rakuyaku.ai',
  LLM_DOMAIN: import.meta.env.VITE_LLM_DOMAIN || 'https://app-llm.rakuyaku.ai',
  DOMAIN: import.meta.env.VITE_DOMAIN || '.rakuyaku.ai',

  SYSTEM_ADMIN: 'rozettastaff',
  SYSTEM_ADMIN_ORG: 'rozetta',

  reloadMessage: 'reload',

  locale: {
    availableLocales: ['en-US', 'ja-JP'],
    defaultLocale: 'ja-JP',
    cookieName: 'NEXT_LOCALE',
  },

  timezone: {
    defaultTimezone: 'Asia/Tokyo',
  },

  docResize: {
    key: 'navWidth_v2',
    defaultSize: 320,
  },

  adminRole: 'rozettastaff',
  adminOrg: 'admin',
  ownerOrg: 'owner',
};

export const REGEX_PASSWORD =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/;

export const REGEX_EMAIL =
  /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/;

export const REGEX_FILE =
  /\(((?:[^\\()]+|\([^\\()]*\))+?\.(?:pdf|docx|txt))\)/gi;

export const REGEX_ID =
  /([^\s();]+)\s*\(\s*([^,()]+)\s*,\s*(document_[\w]+|file_[\w]+)\s*,\s*(\d+)\)/g;

export const COOKIE_MAX_AGE = 60 * 60 * 24;
